<script>
import options from './SearchFilteredTags.options'
export default options
</script>

<template>
  <article v-if="selectedTags && selectedTags.length > 0" class="kb-search-filtered-tags">
    <ul
      aria-label="Valgte filtre"
      class="kb-general-search__tags kb-general-search__active-facets"
    >
      <template v-for="tag in selectedTags" :key="tag.facetName">
        <li>
          <button
            :aria-label="`Fjern filtrering på ${tag.facetName}`"
            class="kb-general-search__tag"
            @click="clearFilterOnTag(tag)"
          >
            {{ tag.facetName }}
            <svg
              role="presentation"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_489_1707)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.29293 3.89701L0.146484 7.04346L0.853591 7.75056L4.00004 4.60412L7.14648 7.75056L7.85359 7.04346L4.70714 3.89701L7.85359 0.750564L7.14648 0.043457L4.00004 3.1899L0.853591 0.043457L0.146484 0.750564L3.29293 3.89701Z"
                  fill="#3C3C3C"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_489_1707">
                  <rect width="8" height="8" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </button>
        </li>
      </template>
    </ul>
  </article>
</template>
